var map = {
	"./antigen": [
		1607,
		365
	],
	"./antigen/": [
		1607,
		365
	],
	"./antigen/index": [
		1607,
		365
	],
	"./antigen/index.tsx": [
		1607,
		365
	],
	"./antigen/style.module.less": [
		3140,
		140
	],
	"./business-inquires": [
		4253,
		263,
		10
	],
	"./business-inquires/": [
		4253,
		263,
		10
	],
	"./business-inquires/index": [
		4253,
		263,
		10
	],
	"./business-inquires/index.tsx": [
		4253,
		263,
		10
	],
	"./business-inquires/style.module.less": [
		5984,
		984
	],
	"./example": [
		7375,
		375
	],
	"./example/": [
		7375,
		375
	],
	"./example/index": [
		7375,
		375
	],
	"./example/index.tsx": [
		7375,
		375
	],
	"./exception/403": [
		7676,
		565,
		293
	],
	"./exception/403/": [
		7676,
		565,
		293
	],
	"./exception/403/index": [
		7676,
		565,
		293
	],
	"./exception/403/index.tsx": [
		7676,
		565,
		293
	],
	"./exception/403/locale": [
		8339,
		339
	],
	"./exception/403/locale/": [
		8339,
		339
	],
	"./exception/403/locale/index": [
		8339,
		339
	],
	"./exception/403/locale/index.ts": [
		8339,
		339
	],
	"./exception/403/style/index.module.less": [
		9325,
		325
	],
	"./exception/404": [
		53,
		565,
		655
	],
	"./exception/404/": [
		53,
		565,
		655
	],
	"./exception/404/index": [
		53,
		565,
		655
	],
	"./exception/404/index.tsx": [
		53,
		565,
		655
	],
	"./exception/404/locale": [
		8895,
		895
	],
	"./exception/404/locale/": [
		8895,
		895
	],
	"./exception/404/locale/index": [
		8895,
		895
	],
	"./exception/404/locale/index.ts": [
		8895,
		895
	],
	"./exception/404/style/index.module.less": [
		541,
		541
	],
	"./faqs": [
		4434,
		957
	],
	"./faqs/": [
		4434,
		957
	],
	"./faqs/index": [
		4434,
		957
	],
	"./faqs/index.tsx": [
		4434,
		957
	],
	"./faqs/style.module.less": [
		7051,
		51
	],
	"./getappointment": [
		4180,
		180
	],
	"./getappointment/": [
		4180,
		180
	],
	"./getappointment/data": [
		3495,
		495
	],
	"./getappointment/data.tsx": [
		3495,
		495
	],
	"./getappointment/index": [
		4180,
		180
	],
	"./getappointment/index.tsx": [
		4180,
		180
	],
	"./getappointment/style.module.less": [
		4679,
		679
	],
	"./index": [
		4751,
		61
	],
	"./index/": [
		4751,
		61
	],
	"./index/index": [
		4751,
		61
	],
	"./index/index.tsx": [
		4751,
		61
	],
	"./index/locale": [
		6674,
		674
	],
	"./index/locale/": [
		6674,
		674
	],
	"./index/locale/index": [
		6674,
		674
	],
	"./index/locale/index.ts": [
		6674,
		674
	],
	"./index/style.module.less": [
		4346,
		346
	],
	"./login": [
		1574,
		263,
		692,
		107
	],
	"./login/": [
		1574,
		263,
		692,
		107
	],
	"./login/banner": [
		7268,
		268
	],
	"./login/banner.tsx": [
		7268,
		268
	],
	"./login/form": [
		7973,
		263,
		692,
		194
	],
	"./login/form.tsx": [
		7973,
		263,
		692,
		194
	],
	"./login/index": [
		1574,
		263,
		692,
		107
	],
	"./login/index.tsx": [
		1574,
		263,
		692,
		107
	],
	"./login/locale": [
		531,
		531
	],
	"./login/locale/": [
		531,
		531
	],
	"./login/locale/index": [
		531,
		531
	],
	"./login/locale/index.ts": [
		531,
		531
	],
	"./login/style/index.module.less": [
		5776,
		776
	],
	"./p": [
		4849,
		849
	],
	"./p/": [
		4849,
		849
	],
	"./p/index": [
		4849,
		849
	],
	"./p/index.tsx": [
		4849,
		849
	],
	"./schedule-covid": [
		97,
		607
	],
	"./schedule-covid/": [
		97,
		607
	],
	"./schedule-covid/index": [
		97,
		607
	],
	"./schedule-covid/index.tsx": [
		97,
		607
	],
	"./schedule-covid/style.module.less": [
		1669,
		669
	],
	"./sexually-transmitted-infections-testing": [
		380,
		860,
		780
	],
	"./sexually-transmitted-infections-testing/": [
		380,
		860,
		780
	],
	"./sexually-transmitted-infections-testing/index": [
		380,
		860,
		780
	],
	"./sexually-transmitted-infections-testing/index.tsx": [
		380,
		860,
		780
	],
	"./sexually-transmitted-infections-testing/style.module.less": [
		7691,
		691
	],
	"./template": [
		1559,
		559
	],
	"./template/": [
		1559,
		559
	],
	"./template/index": [
		1559,
		559
	],
	"./template/index.tsx": [
		1559,
		559
	],
	"./template/style.module.less": [
		4316,
		316
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 717;
module.exports = webpackAsyncContext;